import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import employeeServices from '../employeeServices';
import { CircularProgress } from '@mui/material';
import EmployeIDCardPrint from '../components/EmployeIDCardPrint';
import CompanySelectComponent from '../components/CompanySelectComponent';
import CRMLayout from '../../../../../layout/components/CRMLayout';
import HRMSLayout from '../../../../../layout/components/HRMSLayout';

function EmployeeDetailsPage() {

    const {id} = useParams();

    const [loading,setLoadingStatus] = useState(false);
    const [employeDetails,setEmployeeDetails] = useState(null);
    const [companyDetails,setCompanyDetails] = useState(null);


    const getEmployeeDetails = () =>{
        setLoadingStatus(true);
        employeeServices.getById(id).then(res=>{
            setEmployeeDetails(res.data);
        }).catch(error=>{

        }).finally(()=>{
            setLoadingStatus(false)
        })
    }

    useEffect(()=>{
        getEmployeeDetails();
    },[id])

    return (
        <HRMSLayout>
            {loading && <div className='p-3 text-center'> <CircularProgress /> </div>}
            {!loading &&
                <div className='row'>
                    <div className='col-md-12'>
                        <CompanySelectComponent setCompanyDetails={setCompanyDetails} />
                    </div>
                    <div className='col-md-12'>
                        {companyDetails && employeDetails &&
                        <EmployeIDCardPrint employeDetails={employeDetails} companyDetails={companyDetails} />
                        }
                    </div>
                </div>
            }
        </HRMSLayout>
    )
}

export default EmployeeDetailsPage